import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import api from "../../util/api";

const initialState = {
  createTerminal: {
    loading: false,
  },
  importTerminal: {
    loading: false,
  },
  getTerminal: {
    loading: false,
    data: [],
    pagination: {
      page: 1,
      pageSize: 10,
      totalItems: 0,
    },
  },
  deleteTerminal: {
    loading: false,
  },
  editTerminal: {
    loading: false,
  },
  searchAndGetTerminal: {
    loading: false,
    data: [],
  },
  deleteAllTerminal: {
    loading: false,
  },
  deleteSelectedTerminal: {
    loading: false,
  },
};

//Terminal API call
const asyncCreateTerminal = createAsyncThunk(
  "admin/createTerminal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/terminals/create", payload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncImportTerminal = createAsyncThunk(
  "admin/importTerminal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/terminals/import", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncGetTerminal = createAsyncThunk(
  "admin/getTerminal",
  async (payload, { rejectWithValue }) => {
    const {
      page = 1,
      limit = 10,
      sortByColumn = "",
      sortOrder = "",
      q = "",
    } = payload;
    try {
      const response = await api.get(
        `/api/terminals?page=${page}&limit=${limit}&sortByColumn=${sortByColumn}&sortOrder=${sortOrder}&q=${q}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteTerminal = createAsyncThunk(
  "admin/deleteTerminal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/terminals/${payload}`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncEditTerminal = createAsyncThunk(
  "admin/editTerminal",
  async (payload, { rejectWithValue }) => {
    const { id, ...restPayload } = payload;
    try {
      const response = await api.put(`/api/terminals/${id}`, restPayload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncSearchAndGetTerminal = createAsyncThunk(
  "admin/searchAndGetTerminal",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/terminals/search`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteAllTerminal = createAsyncThunk(
  "admin/deleteAllTerminal",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/api/terminals/delete-all`);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

const asyncDeleteSelectedTerminal = createAsyncThunk(
  "admin/deleteSelectedTerminal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(`/api/terminals/delete-many`, payload);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message,
      });
    }
  }
);

export const terminalSlice = createSlice({
  name: "terminal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create terminal
    builder.addCase(asyncCreateTerminal.pending, (state) => {
      state.createTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncCreateTerminal.fulfilled, (state) => {
      state.createTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncCreateTerminal.rejected, (state) => {
      state.createTerminal = {
        loading: false,
      };
    });
    // import terminal
    builder.addCase(asyncImportTerminal.pending, (state) => {
      state.importTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncImportTerminal.fulfilled, (state) => {
      state.importTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncImportTerminal.rejected, (state) => {
      state.importTerminal = {
        loading: false,
      };
    });
    // get terminal
    builder.addCase(asyncGetTerminal.pending, (state) => {
      state.getTerminal = {
        loading: true,
        data: state.getTerminal.data || [],
        pagination: state.getTerminal.pagination,
      };
    });
    builder.addCase(asyncGetTerminal.fulfilled, (state, action) => {
      state.getTerminal = {
        loading: false,
        data: action.payload.data.results || [],
        pagination:
          action.payload.data.pagination || state.getTerminal.pagination,
      };
    });
    builder.addCase(asyncGetTerminal.rejected, (state) => {
      state.getTerminal = {
        loading: false,
        data: [],
        pagination: {
          page: 1,
          pageSize: 10,
          totalItems: 0,
        },
      };
    });
    // delete terminal
    builder.addCase(asyncDeleteTerminal.pending, (state) => {
      state.deleteTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteTerminal.fulfilled, (state) => {
      state.deleteTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteTerminal.rejected, (state) => {
      state.deleteTerminal = {
        loading: false,
      };
    });
    // edit terminal
    builder.addCase(asyncEditTerminal.pending, (state) => {
      state.editTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncEditTerminal.fulfilled, (state) => {
      state.editTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncEditTerminal.rejected, (state) => {
      state.editTerminal = {
        loading: false,
      };
    });
    // search and get terminal
    builder.addCase(asyncSearchAndGetTerminal.pending, (state) => {
      state.searchAndGetTerminal = {
        loading: true,
        data: state.searchAndGetTerminal.data || [],
      };
    });
    builder.addCase(asyncSearchAndGetTerminal.fulfilled, (state, action) => {
      state.searchAndGetTerminal = {
        loading: false,
        data: action.payload.data.results || state.searchAndGetTerminal.data,
      };
    });
    builder.addCase(asyncSearchAndGetTerminal.rejected, (state) => {
      state.searchAndGetTerminal = {
        loading: false,
        data: [],
      };
    });
    // delete all terminal
    builder.addCase(asyncDeleteAllTerminal.pending, (state) => {
      state.deleteAllTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteAllTerminal.fulfilled, (state) => {
      state.deleteAllTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteAllTerminal.rejected, (state) => {
      state.deleteAllTerminal = {
        loading: false,
      };
    });
    // delete selected terminal
    builder.addCase(asyncDeleteSelectedTerminal.pending, (state) => {
      state.deleteSelectedTerminal = {
        loading: true,
      };
    });
    builder.addCase(asyncDeleteSelectedTerminal.fulfilled, (state) => {
      state.deleteSelectedTerminal = {
        loading: false,
      };
    });
    builder.addCase(asyncDeleteSelectedTerminal.rejected, (state) => {
      state.deleteSelectedTerminal = {
        loading: false,
      };
    });
  },
});

export {
  asyncCreateTerminal,
  asyncImportTerminal,
  asyncGetTerminal,
  asyncDeleteTerminal,
  asyncEditTerminal,
  asyncSearchAndGetTerminal,
  asyncDeleteAllTerminal,
  asyncDeleteSelectedTerminal,
};

export default terminalSlice.reducer;
